import React from 'react';
import { Menu, MenuItem, Typography } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const ContextMenu = ({
  contextMenu,
  selectedOption,
  setSelectedOption,
  handleMenuItemClick,
  classes,
  theme,
  t,
  diagnostics_microcalc_module,
  diagnostics_opacities_module,
  closeMenu,
}) => {
  if (!contextMenu) return null;

  const microcalcClassesItems = [
    { label: 'vessel', class: 'vessel' },
    { label: 'birads_2', class: 'birads2' },
    { label: 'birads_3', class: 'birads3' },
    { label: 'birads_4', class: 'birads4' },
    { label: 'birads_5', class: 'birads5' },
  ];

  const opacitiesClassesItems = [
    { label: 'birads_2', class: 'birads2' },
    { label: 'birads_3', class: 'birads3' },
    { label: 'birads_4', class: 'birads4' },
    { label: 'birads_5', class: 'birads5' },
    { label: 'lesionKnown', class: 'lesionKnown' },
  ];

  const renderMenuItems = (items, type) =>
    items.map((item) => (
      <MenuItem
        key={item.label}
        disabled={contextMenu?.rectangleType === type && contextMenu.rectangleClass === item.class}
        className={classes.menu_item_text}
        onClick={() => handleMenuItemClick(item.class)}
        style={{ color: theme.palette.diagnosticsClasses[item.class] }}
      >
        {t(`projections.${item.label}`)}
      </MenuItem>
    ));

  return (
    <Menu
      keepMounted
      open={true}
      onClose={closeMenu}
      anchorReference='anchorPosition'
      anchorPosition={{ top: contextMenu.mouseY, left: contextMenu.mouseX }}
    >
      <MenuItem
        onClick={() => setSelectedOption({ option: 'reassign', rectId: contextMenu.rectangleId })}
        className={classes.menu_item_container}
      >
        <Typography className={classes.menu_item_text}>
          {contextMenu.rectangleType ? t('projections.reassign') : t('projections.assign')}
        </Typography>
        <ArrowForwardIosIcon fontSize='small' className={classes.menu_item_icon} />
      </MenuItem>

      {/* Submenu for reassign */}
      <Menu
        open={selectedOption?.option === 'reassign'}
        onClose={closeMenu}
        anchorReference='anchorPosition'
        anchorPosition={
          selectedOption?.option === 'reassign'
            ? { top: contextMenu.mouseY + 20, left: contextMenu.mouseX + 94 }
            : undefined
        }
      >
        {diagnostics_microcalc_module && (
          <MenuItem
            onClick={() => setSelectedOption({ ...selectedOption, type: 'microcalc' })}
            className={classes.menu_item_container}
          >
            <Typography className={classes.menu_item_text}>{t('projections.microcalcifications')}</Typography>
            <ArrowForwardIosIcon fontSize='small' className={classes.menu_item_icon} />
          </MenuItem>
        )}

        {/* Microcalc submenu */}
        <Menu
          open={selectedOption?.type === 'microcalc'}
          onClose={closeMenu}
          anchorReference='anchorPosition'
          anchorPosition={
            selectedOption?.type === 'microcalc'
              ? {
                  top: contextMenu.mouseY + 30,
                  left: contextMenu.mouseX + 230,
                }
              : undefined
          }
        >
          {renderMenuItems(microcalcClassesItems, 'microcalc')}
        </Menu>

        {diagnostics_opacities_module && (
          <MenuItem
            onClick={() => setSelectedOption({ ...selectedOption, type: 'opacities' })}
            className={classes.menu_item_container}
          >
            <Typography className={classes.menu_item_text}>{t('projections.opacity')}</Typography>
            <ArrowForwardIosIcon fontSize='small' className={classes.menu_item_icon} />
          </MenuItem>
        )}

        {/* Opacities submenu */}
        <Menu
          open={selectedOption?.type === 'opacities'}
          onClose={closeMenu}
          anchorReference='anchorPosition'
          anchorPosition={
            selectedOption?.type === 'opacities'
              ? {
                  top: contextMenu.mouseY + 70,
                  left: contextMenu.mouseX + 230,
                }
              : undefined
          }
        >
          {renderMenuItems(opacitiesClassesItems, 'opacities')}
        </Menu>
      </Menu>

      <MenuItem
        onClick={() => handleMenuItemClick('delete')}
        onMouseOver={() => setSelectedOption({ type: 'delete' })}
        className={classes.menu_item_container}
      >
        <Typography className={classes.menu_item_text}>{t('projections.delete')}</Typography>
        <DeleteIcon fontSize='small' className={classes.menu_item_icon} />
      </MenuItem>
    </Menu>
  );
};

export default ContextMenu;
